var _path, _path2, _rect, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailedPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 143,
    viewBox: "0 0 203 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.937 96.5999C112.937 95.0999 24.4373 48.8002 24.4373 30.5999C24.4373 19.6801 52.8608 16.7422 91 23.6085",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.438 114.6C99.5 124.5 32.001 109.856 32.001 109.856",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.8394,
    y: 67.9485,
    width: 140,
    height: 90,
    rx: 8,
    transform: "rotate(-30 24.8394 67.9485)",
    fill: "#FF1E1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3394,
    y: 87.8671,
    width: 140,
    height: 12,
    transform: "rotate(-30 36.3394 87.8671)",
    fill: "#24594B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.938 96.6C252.938 98.1 110.438 60.5999 27.4379 78.5999C-14.267 87.6444 -2.06853 100.981 32.001 109.856",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPayment);
export default __webpack_public_path__ + "static/media/failed_payment.085e3dfd213ec6df285f3a5b7c64b20e.svg";
export { ForwardRef as ReactComponent };